
const avatarColors = [
  '#808080',
  '#2F4F4F',
  '#A52A2A',
  '#808000',
  '#DAA520',
  '#F4A460',
  '#4169E1',
  '#1E90FF',
  '#5F9EA0',
  '#00CED1',
  '#556B2F',
  '#008000',
  '#FF4500',
  '#FF8C00',
  '#DC143C',
  '#B22222',
  '#9932CC',
  '#663399',
  '#C71585'
]

export function getRandomAvatarColor () {
  const i = Math.floor(Math.random() * Math.floor(avatarColors.length))
  return avatarColors[i]
}

export function getAvatarChar (...names) {
  for (const name of names) {
    if (name) return name[0]
  }

  return ''
}
